import { useState } from 'react';

export type OnDone<T = boolean> = (emailChanged: T) => void;

export default function useEditEmailAddressController(onDone: OnDone) {
  const [newEmail, setNewEmail] = useState('');
  const [modalToShow, setModalToShow] = useState<'update-email' | 'verify-email'>('update-email');

  function handleCancelEditEmail() {
    onDone(false);
  }

  function handleNewEmailEntered(newEmail: string) {
    setNewEmail(newEmail);
    setModalToShow('verify-email');
  }

  function handleEmailChanged() {
    onDone(true);
  }

  return { modalToShow, handleCancelEditEmail, newEmail, handleNewEmailEntered, handleEmailChanged };
}
